import CodeanywhereLogo from '../../assets/img/logo/codeanywhere-logo.svg'
import CodeanywhereGlyph from '../../assets/img/logo/codeanywhere-glyph.svg'
import CodeanywhereFull from '../../assets/img/logo/codeanywhere-logo-full-color.svg'

export const LOGO: { [x: string]: string } = {
  CodeanywhereLogo,
  CodeanywhereGlyph,
  CodeanywhereFull,
}
